// image.service.ts
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { getStoredAuthToken } from '../../auth/auth-token';

@Injectable({ providedIn: 'root' })
export class UserWatchListService {
  private readonly platformId = inject(PLATFORM_ID);

  constructor(private http: HttpClient) { }

  addToUserWatchList(data:any): Observable<any> {
    return this.http.post<any>(`${environment.backendUrl}/api/watchlist/add`, data, {
      headers: this.authHeaders(),
    });
  }

  getUserWatchList(): Observable<any> {
    return this.http.get<any>(`${environment.backendUrl}/api/watchlist/user`, {
      headers: this.authHeaders(),
    });
  }

  removeFromWatchList(id: string) {
    const params = new HttpParams().set('id', id ?? 0)

    return this.http.delete<any>(`${environment.backendUrl}/api/watchlist/remove`, {
      headers: this.authHeaders(),
      params,
    });
  }

  private authHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: `Bearer ${this.getAuthToken() ?? ''}`,
    });
  }

  private getAuthToken(): string | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }

    return getStoredAuthToken();
  }
}
